module.exports = __webpack_public_path__ + "static/media/omkar_kale.72cbd2b4.png";